import React, { createContext, useContext, useEffect, useState } from 'react';

import { getSharedContext } from '../api/Shared';

const DEFAULT_VALUE = {
  stripePublicKey: '',
};

const SharedContext = createContext(DEFAULT_VALUE);

export const SharedContextProvider = ({ children }) => {
  const [value, setValue] = useState(DEFAULT_VALUE);

  useEffect(() => {
    const loadSharedContext = async () => {
      try {
        const { data } = await getSharedContext();
        setValue({
          stripePublicKey: data.stripe_public_key || '',
        });
      } catch (e) {
        // empty
      }
    };
    loadSharedContext();
  }, []);

  return (
    <SharedContext.Provider value={value}>{children}</SharedContext.Provider>
  );
};

export const useSharedContext = () => useContext(SharedContext);
